import React, { useState } from 'react';
import Lottie from 'react-lottie';
import { Document, Page } from 'react-pdf/dist/umd/entry.webpack';
import useResizeObserver from 'use-resize-observer';
import * as Routes from '../../../scripts/routes';
import animationData from '../../lotties/reading-document.json';

const RenderPdfSo = React.memo(({numeroAno, file, handleProcessandoPdf}) => {
  const [numPages, setNumPages]      = useState(null);
  const {ref, width = 1, height = 1} = useResizeObserver();
  const fileUrl                      = numeroAno && file?.id ? Routes.documento_so_processo_path(numeroAno, {id: file?.id}) : '';

  const onDocumentLoadSuccess = ({numPages}) => {
    setNumPages(numPages);
    handleProcessandoPdf(false);
  };

  const onDocumentLoadError = (_error) => {
    handleProcessandoPdf(false);
  };

  const noData =
          <div className='d-flex align-items-center justify-content-center text-muted'
               style={{height: height * 0.9}}>
            <div className='text-center'>
              <div className='d-block' style={{fontSize: '10rem'}}>
                <i className='fas fa-file-import'></i>
              </div>
              <h2 className='d-block'>
                Sem documento selecionado.
              </h2>
            </div>
          </div>;

  const errorData =
          <div className='d-flex align-items-center justify-content-center text-warning'
               style={{height: height * 0.9}}>
            <div className='text-center'>
              <div className='d-block' style={{fontSize: '10rem'}}>
                <i className='fas fa-file-excel'></i>
              </div>
              <h2 className='d-block'>Problemas ao ler documento.</h2>
            </div>
          </div>;

  const loadingData =
          <div className='d-flex align-items-center justify-content-center text-muted text-center p-5'
               style={{height: height * 0.9}}>
            <div className='text-center'>
              <div className='ml-4'>
                <Lottie
                  options={{
                    loop:          true,
                    autoplay:      true,
                    animationData: animationData
                  }}
                  width={250}
                  height={300}
                />
              </div>
              <h2 style={{marginTop: '-45px'}} className='text-wrap'>{file?.nome}</h2>
            </div>
          </div>;

  return (
    <div ref={ref} className='vh-100 animate__animated animate__fadeIn'>
      <Document
        file={fileUrl}
        noData={noData}
        loading={loadingData}
        error={errorData}
        renderMode='canvas'
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
      >
        <div>
          <nav className='navbar navbar-dark sticky-top shadow-lg' style={{backgroundColor: '#828282'}}>
            <div className='container-fluid'>
              <span className='navbar-brand mb-0 h1'>Total de Páginas: {numPages}</span>

              <a className='btn btn-link btn-sm bg-white'
                 title='baixar documento'
                 target='_blank'
                 href={fileUrl + '?download_file=true'}
                 rel='nofollow'>
                <i className='fas fa-file-download m-1' style={{fontSize: '1.8rem'}}></i>
              </a>
            </div>
          </nav>
          {Array.from(
            new Array(numPages),
            (el, index) => (
              <span key={`page_${index + 1}`}>
                <Page
                  className={'animate__animated animate__fadeIn'}
                  pageNumber={index + 1}
                  width={width}
                />
                {(numPages != (index + 1)) && <hr />}
              </span>
            )
          )}
        </div>
      </Document>
    </div>
  );
});

export default RenderPdfSo;
